/**
 * Slugify a string.
 *
 * @param {string} $text
 *
 * @return {string}
 */
export function slugify( $text ) {
    return $text
        .toLowerCase()
        .replace( / /g, '-' )
        .replace( /[^\w-]+/g, '' );
}
